import React from "react"
//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useTranslation } from "react-i18next"
import CreatorsTable from "./CreatorsTable"
export default function CreatorsList() {
  const { t } = useTranslation()
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("pages.Creators")} />

        <CreatorsTable />
      </div>
    </div>
  )
}
